var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "brick-settings-base",
        {
          attrs: {
            title: _vm.resource(
              "JourneyComposer_BrickSettingsTouchpoint_Title"
            ),
            canWrite: _vm.canWrite,
            prompt: {
              title: _vm.resource(
                "JourneyBuilder_TouchpointSettings_Delete_Title"
              ),
              body: _vm.resource(
                "JourneyBuilder_TouchpointSettings_Delete_Body"
              )
            }
          },
          on: {
            save: _vm.save,
            delete: function($event) {
              return _vm.$emit("delete")
            },
            hidden: function($event) {
              return _vm.$emit("hide")
            }
          },
          model: {
            value: _vm.newName,
            callback: function($$v) {
              _vm.newName = $$v
            },
            expression: "newName"
          }
        },
        [
          _c(
            "property",
            {
              attrs: {
                label: _vm.resource(
                  "JourneyComposer_BrickSettingsTouchpoint_ParentType_DisplayName"
                )
              }
            },
            [
              _c(
                "input-group",
                { attrs: { icon: "far fa-edit" } },
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "form-control",
                      attrs: {
                        options: _vm.touchPointParentTypes,
                        disabled:
                          !_vm.canWrite ||
                          _vm.touchPointParentTypes.length === 0,
                        clearable: false,
                        searchable: "",
                        filterable: ""
                      },
                      model: {
                        value: _vm.settings.touchpointParentType,
                        callback: function($$v) {
                          _vm.$set(_vm.settings, "touchpointParentType", $$v)
                        },
                        expression: "settings.touchpointParentType"
                      }
                    },
                    [
                      _c("div", {
                        attrs: { slot: "no-options" },
                        slot: "no-options"
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "property",
            {
              attrs: {
                label: _vm.resource(
                  "JourneyComposer_BrickSettingsTouchpoint_Type_DisplayName"
                )
              }
            },
            [
              _c(
                "input-group",
                { attrs: { icon: "far fa-edit" } },
                [
                  _c(
                    "v-select",
                    {
                      ref: "subtype",
                      staticClass: "form-control",
                      attrs: {
                        label: "name",
                        options: _vm.availableTouchPointTypes,
                        disabled:
                          !_vm.canWrite ||
                          _vm.availableTouchPointTypes.length === 0,
                        clearable: false,
                        searchable: "",
                        filterable: ""
                      },
                      model: {
                        value: _vm.selectedTouchPointType,
                        callback: function($$v) {
                          _vm.selectedTouchPointType = $$v
                        },
                        expression: "selectedTouchPointType"
                      }
                    },
                    [
                      _c("div", {
                        attrs: { slot: "no-options" },
                        slot: "no-options"
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "property",
            {
              attrs: {
                label: _vm.resource(
                  "JourneyBuilder_FilterSettings_Arrival_DisplayName"
                )
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.resource(
                      "JourneyBuilder_FilterSettings_Arrival_Description"
                    )
                  ) +
                  "\n        "
              ),
              _c("arrival", {
                attrs: { availableConditions: _vm.availableArrivalConditions },
                model: {
                  value: _vm.settings.arrivalCondition,
                  callback: function($$v) {
                    _vm.$set(_vm.settings, "arrivalCondition", $$v)
                  },
                  expression: "settings.arrivalCondition"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "property",
            {
              attrs: {
                label: _vm.resource(
                  "JourneyBuilder_FilterSettings_Goal_DisplayName"
                )
              }
            },
            [
              _c("toggle", {
                attrs: {
                  sync: true,
                  labels: {
                    checked: _vm.resource("Bool_Yes"),
                    unchecked: _vm.resource("Bool_No")
                  },
                  width: 78
                },
                model: {
                  value: _vm.settings.goal,
                  callback: function($$v) {
                    _vm.$set(_vm.settings, "goal", $$v)
                  },
                  expression: "settings.goal"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("custom-conditions", {
            attrs: {
              canWrite: _vm.canWrite,
              parentType: _vm.settings.touchpointParentType
            },
            model: {
              value: _vm.settings.customConditions,
              callback: function($$v) {
                _vm.$set(_vm.settings, "customConditions", $$v)
              },
              expression: "settings.customConditions"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }